export default __webpack_public_path__ + "static/media/img-guide-gt-popup-1-fr_fr.f21396ab.png";